export enum MapTypes {
  DEFAULT = 'roadmap',
  SATELLITE = 'satellite',
}